import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

/**
 * Creates a new Rapidoo product
 */
export const createProduct = {
  url() {
    return buildApiUrl(ADMIN_ENDPOINTS.PRODUCTS_ADD)
  },
  method: 'POST',
  format(payload) {
    const { name, description, price, target, category, stock, image, currency } = payload || {}
    return { 
      name, 
      description: description || '', 
      price: parseInt(price, 10) || 0, 
      target: target || 'restaurant', 
      category: category || '', 
      stock: parseInt(stock, 10) || 1, 
      image: image || '', 
      currency: currency || 'XOF' 
    }
  },
  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) return { statusCode: raw?.statusCode || 400, message: raw?.message || 'Erreur lors de la création', data: null }
    return { statusCode: 200, message: 'Produit créé avec succès', data: raw.data }
  },
}

/**
 * Updates an existing Rapidoo product
 */
export const updateProduct = {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.PRODUCTS_UPDATE, { pathParams: { id } })
  },
  method: 'PUT',
  format(payload) {
    const { name, description, price, target, category, stock, image, currency } = payload || {}
    return { 
      name, 
      description: description || '', 
      price: parseInt(price, 10) || 0, 
      target: target || 'restaurant', 
      category: category || '', 
      stock: parseInt(stock, 10) || 1, 
      image: image || '', 
      currency: currency || 'XOF' 
    }
  },
  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) return { statusCode: raw?.statusCode || 400, message: raw?.message || 'Erreur lors de la mise à jour', data: null }
    return { statusCode: 200, message: 'Produit mis à jour avec succès', data: raw.data }
  },
}

/**
 * Deletes a Rapidoo product (maps to Deactivate in V3 API)
 */
export const deleteProduct = {
  url(payload) {
    const { id } = payload || {}
    // V3 API uses deactivate instead of DELETE
    return buildApiUrl(ADMIN_ENDPOINTS.PRODUCT_DEACTIVATE, { pathParams: { id } })
  },
  method: 'PATCH',
  format() { return {} },
  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) return { statusCode: raw?.statusCode || 400, message: raw?.message || 'Erreur lors de la suppression', data: null }
    return { statusCode: 200, message: 'Produit supprimé (désactivé)', data: null }
  },
}

/**
 * Activates a product
 */
export const activateProduct = {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.PRODUCT_ACTIVATE, { pathParams: { id } })
  },
  method: 'PATCH',
  format() { return {} },
  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) return { statusCode: raw?.statusCode || 400, message: raw?.message || 'Erreur lors de l\'activation', data: null }
    return { statusCode: 200, message: 'Produit activé', data: raw.data }
  },
}

/**
 * Deactivates a product
 */
export const deactivateProduct = {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.PRODUCT_DEACTIVATE, { pathParams: { id } })
  },
  method: 'PATCH',
  format() { return {} },
  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) return { statusCode: raw?.statusCode || 400, message: raw?.message || 'Erreur lors de la désactivation', data: null }
    return { statusCode: 200, message: 'Produit désactivé', data: raw.data }
  },
}

/**
 * Updates a product purchase status
 */
export const updatePurchaseStatus = {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.PRODUCT_PURCHASE_STATUS, { pathParams: { id } })
  },
  method: 'PATCH',
  format(payload) {
    const { status } = payload || {}
    return { status }
  },
  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) return { statusCode: raw?.statusCode || 400, message: raw?.message || 'Erreur lors de la mise à jour du statut', data: null }
    return { statusCode: 200, message: 'Statut mis à jour', data: raw.data }
  },
}

export default { createProduct, updateProduct, deleteProduct, activateProduct, deactivateProduct, updatePurchaseStatus }
